
import {defineComponent, ref, reactive, onMounted, computed, watch} from "vue";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import AddUaProjectModal from "@/components/modals/forms/AddUaProjectModal.vue";
import UpdateUaReportModal from "@/components/modals/forms/UpdateUaReportModal.vue";
import DeleteModal from "@/components/modals/forms/DeleteModal.vue";
import { MenuComponent } from "@/assets/ts/components";
import {Client, UaProject} from "@/store/modules/ApiModule";
import {useStore} from "vuex";
import {Actions} from "@/store/enums/StoreEnums";

export default defineComponent({
  name: "ua-projects-listing",
  components: {
    Datatable,
    AddUaProjectModal,
    UpdateUaReportModal,
    DeleteModal
  },
  setup() {
    const tableHeader = ref([
      {
        name: "Name",
        key: "name",
        sortable: true,
      },
      {
        name: "Client",
        key: "client",
        sortable: true,
      },
      {
        name: "Update",
        key: "update",
      },
      {
        name: "Actions",
        key: "actions",
      },
    ]);


    const store = useStore();
    let myUaProjects = ref<Array<UaProject>>([]);
    let selectedItem = reactive({} as UaProject);

    let myData = computed(() => {
      return store.state.api.uaProjects;
    });

    const setSelectedItem = (item) => {
      if(item == null){
        Object.assign(selectedItem, {
          id: 0, name: "", client_id: "", tracker_id: "", dashboard: "", spreadsheet: "", client: {}
        });
      }
      else {
        Object.assign(selectedItem, item);
      }
    }

    onMounted(() => {
      MenuComponent.reinitialization();
      store.dispatch(Actions.LOAD_UAPROJECTS);
    });

    watch(myData, (newValue, oldValue) => {
      myUaProjects.value.splice(0,myUaProjects.value.length)
      newValue.forEach(function (value) {
        myUaProjects.value.push(value);
      });
    });

    const search = ref<string>("");
    const searchItems = () => {
      /*tableData.value.splice(0, tableData.value.length, ...initClients.value);
      if (search.value !== "") {
        let results: Array<Client> = [];
        for (let j = 0; j < tableData.value.length; j++) {
          if (searchingFunc(tableData.value[j], search.value)) {
            results.push(tableData.value[j]);
          }
        }
        tableData.value.splice(0, tableData.value.length, ...results);
      }*/
    };

    const searchingFunc = (obj, value): boolean => {
      for (let key in obj) {
        if (!Number.isInteger(obj[key]) && !(typeof obj[key] === "object")) {
          if (obj[key].indexOf(value) != -1) {
            return true;
          }
        }
      }
      return false;
    };

    return {
      myData,
      myUaProjects,
      selectedItem,
      setSelectedItem,
      tableHeader,
      search,
      searchItems
    };
  },
});
